




































import { Vue, Prop, Lifecycle, Component, p, Watch } from "av-ts";
import { IBadge } from "../../interfaces/models";

import UserBadge from "../util/UserBadge.vue";
import BadgeService from "../../services/BadgeService";
import Fetcher from "../../services/Fetcher";

@Component({
    components: {
        "user-badge": UserBadge
    }
})
export default class CollectedBadges extends Vue {
    @Prop topic = p<string>({
        required: true
    });

    @Prop
    userID = p<number>({
        required: false,
        default: -1
    });

    pAvailableBadges: IBadge[] = [];

    updateAvailableBadges(newBadges: IBadge[]) {
        this.pAvailableBadges = newBadges;
    };

    @Lifecycle
    created() {
        Fetcher.get(BadgeService.getAllUserBadges, { userID: this.userID })
            .on(this.updateAvailableBadges);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(BadgeService.getAllUserBadges, { userID: this.userID })
            .off(this.updateAvailableBadges);
    }

    @Watch("userID")
    changeUser(newUser: number, oldUser: number) {
        Fetcher.get(BadgeService.getAllUserBadges, { userID: oldUser })
            .off();
        Fetcher.get(BadgeService.getAllUserBadges, { userID: newUser })
            .on(this.updateAvailableBadges);
    }

    get availableBadges() {
        if (this.topic == "closest") {
            return BadgeService.getClosestUserBadges(this.pAvailableBadges);
        } else if (this.topic == "all") {
            return this.pAvailableBadges;
        } else {
            return BadgeService.getBadgesByCategory(this.pAvailableBadges, this.topic);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/util/CollectedBadges.vue